// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.region-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px 14px;
}

.field-row {
  display: flex;
  gap: 8px;
}
.field-row ion-input.styled-input {
  flex: 1;
  font-size: var(--font-size-small);
}

.draw-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-top: 4px;
}

.draw-btn {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 14px;
  border-radius: 10px;
  border: 1.5px dashed rgba(var(--ion-color-primary-rgb), 0.5);
  background: rgba(var(--ion-color-primary-rgb), 0.05);
  color: var(--ion-color-primary);
  font-size: var(--font-size-small);
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease;
  text-align: left;
}
.draw-btn ion-icon {
  font-size: 18px;
  flex-shrink: 0;
}
.draw-btn .required-badge {
  margin-left: auto;
  font-size: 10px;
  font-weight: 500;
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.09);
  padding: 2px 7px;
  border-radius: 8px;
  flex-shrink: 0;
}
.draw-btn .done-icon {
  margin-left: auto;
  font-size: 19px;
  color: var(--ion-color-success);
}
.draw-btn:hover:not([disabled]) {
  background: rgba(var(--ion-color-primary-rgb), 0.1);
  border-color: var(--ion-color-primary);
}
.draw-btn.drawn, .draw-btn[disabled] {
  border-style: solid;
  border-color: rgba(var(--ion-color-success-rgb), 0.45);
  background: rgba(var(--ion-color-success-rgb), 0.06);
  color: var(--ion-color-success-shade);
  cursor: default;
}

.remove-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  border-radius: 10px;
  border: 1px solid rgba(var(--ion-color-danger-rgb), 0.28);
  background: rgba(var(--ion-color-danger-rgb), 0.05);
  color: var(--ion-color-danger);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  flex-shrink: 0;
}
.remove-btn ion-icon {
  font-size: 19px;
}
.remove-btn:hover:not([disabled]) {
  background: rgba(var(--ion-color-danger-rgb), 0.12);
  border-color: var(--ion-color-danger);
}
.remove-btn[disabled] {
  opacity: 0.35;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/app/components/trajectory-creation/select-region-area/components/new-region-card/new-region-card.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AADF;;AAMA;EACE,aAAA;EACA,QAAA;AAHF;AAKE;EACE,OAAA;EACA,iCAAA;AAHJ;;AASA;EACE,aAAA;EACA,oBAAA;EACA,QAAA;EACA,eAAA;AANF;;AASA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,4DAAA;EACA,oDAAA;EACA,+BAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;EACA,gBAAA;AANF;AAQE;EACE,eAAA;EACA,cAAA;AANJ;AASE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,mDAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAPJ;AAUE;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;AARJ;AAWE;EACE,mDAAA;EACA,sCAAA;AATJ;AAYE;EAEE,mBAAA;EACA,sDAAA;EACA,oDAAA;EACA,qCAAA;EACA,eAAA;AAXJ;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,yDAAA;EACA,mDAAA;EACA,8BAAA;EACA,eAAA;EACA,0DAAA;EACA,cAAA;AAZF;AAcE;EACE,eAAA;AAZJ;AAeE;EACE,mDAAA;EACA,qCAAA;AAbJ;AAgBE;EACE,aAAA;EACA,eAAA;AAdJ","sourcesContent":["// ── Region form — matches select-region-area design language ──────────────\r\n\r\n.region-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: 10px 12px 14px;\r\n}\r\n\r\n// ── Field rows ────────────────────────────────────────────────────────────\r\n\r\n.field-row {\r\n  display: flex;\r\n  gap: 8px;\r\n\r\n  ion-input.styled-input {\r\n    flex: 1;\r\n    font-size: var(--font-size-small);\r\n  }\r\n}\r\n\r\n// ── Draw / remove row ─────────────────────────────────────────────────────\r\n\r\n.draw-row {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 8px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.draw-btn {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 11px 14px;\r\n  border-radius: 10px;\r\n  border: 1.5px dashed rgba(var(--ion-color-primary-rgb), 0.5);\r\n  background: rgba(var(--ion-color-primary-rgb), 0.05);\r\n  color: var(--ion-color-primary);\r\n  font-size: var(--font-size-small);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.18s ease, border-color 0.18s ease;\r\n  text-align: left;\r\n\r\n  ion-icon {\r\n    font-size: 18px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .required-badge {\r\n    margin-left: auto;\r\n    font-size: 10px;\r\n    font-weight: 500;\r\n    color: var(--ion-color-danger);\r\n    background: rgba(var(--ion-color-danger-rgb), 0.09);\r\n    padding: 2px 7px;\r\n    border-radius: 8px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .done-icon {\r\n    margin-left: auto;\r\n    font-size: 19px;\r\n    color: var(--ion-color-success);\r\n  }\r\n\r\n  &:hover:not([disabled]) {\r\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\r\n    border-color: var(--ion-color-primary);\r\n  }\r\n\r\n  &.drawn,\r\n  &[disabled] {\r\n    border-style: solid;\r\n    border-color: rgba(var(--ion-color-success-rgb), 0.45);\r\n    background: rgba(var(--ion-color-success-rgb), 0.06);\r\n    color: var(--ion-color-success-shade);\r\n    cursor: default;\r\n  }\r\n}\r\n\r\n.remove-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 42px;\r\n  border-radius: 10px;\r\n  border: 1px solid rgba(var(--ion-color-danger-rgb), 0.28);\r\n  background: rgba(var(--ion-color-danger-rgb), 0.05);\r\n  color: var(--ion-color-danger);\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease;\r\n  flex-shrink: 0;\r\n\r\n  ion-icon {\r\n    font-size: 19px;\r\n  }\r\n\r\n  &:hover:not([disabled]) {\r\n    background: rgba(var(--ion-color-danger-rgb), 0.12);\r\n    border-color: var(--ion-color-danger);\r\n  }\r\n\r\n  &[disabled] {\r\n    opacity: 0.35;\r\n    cursor: default;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
